<!--
 * @Description: 自由职业者综合服务协议 之 补充协议
 * @Author: ljl
 * @Date: 2024-07-25
-->
<template>
  <div class="contract-main" :style="{ height: modalHeight }">
    <div class="contract-content">
      <div class="title">《自由职业者综合服务协议》之补充协议</div>
      <span class="text marginBottom23"
        >本《<自由职业者综合服务协议>之补充协议》(以下简称 "本协议")
        由以下双方于【{{ resCooperatorData.year }}】年【{{
          resCooperatorData.month
        }}】月【{{ resCooperatorData.day }}】日签署：</span
      >
      <span class="text marginBottom8"
        >甲方：【{{ resCooperatorData.cooperatorName }}】</span
      >
      <span class="text marginBottom8"
        >法定代表人：【{{ resCooperatorData.userName }}】</span
      >
      <span class="text marginBottom23"
        >统一社会信用代码：【{{ resCooperatorData.uscCode }}】</span
      >
      <span class="text marginBottom13"
        >乙方：【{{ resCooperatorData.distributeCompanyName }}】</span
      >
      <span class="text marginBottom8"
        >法定代表人：【{{ resCooperatorData.disCompanyLegalPerson }}】</span
      >
      <span class="text marginBottom23"
        >地址：【{{ resCooperatorData.disCompanyAddress }}】</span
      >
      <div>
        <div class="marginBottom13 text">鉴于：</div>
        <div class="display_flex_box marginBottom13">
          <span class="indent20_box">1、</span>
          <div class="text_black">
            <span
              >甲乙双方于【{{ resCooperatorData.beforeYear }}】年【{{
                resCooperatorData.beforeMonth
              }}】月【{{
                resCooperatorData.beforeDay
              }}】日签订了《自由职业者综合服务协议》(《自由职业者综合服务协议》及其任何修订与补充，以下简称 "主协议");</span
            >
          </div>
        </div>
        <div class="display_flex_box marginBottom13">
          <span class="indent20_box">2、</span>
          <div class="text_black">
            <span>现甲乙双方共同商定调整协议部分内容。</span>
          </div>
        </div>
        <div class="display_flex_box marginBottom13">
          <span class="indent20_box"></span>
          <div class="text_black margin_box">
            <span>
              双方就上述事项经平等友好协商，根据相关法律法规，按照平等、诚实守信等主则达成及签订本补充协议如下：</span
            >
          </div>
        </div>
      </div>
      <div class="text marginBottom13">第一条 修改内容</div>
      <div class="display_flex_box marginBottom13">
        <div class="text_black indent20_box">
          <span class="text">甲乙双方共同商定，修改主协议以下内容</span>
        </div>
      </div>
      <div class="display_flex_box marginBottom13">
        <div class="text_black indent20_box">
          <span>经过双方友好协商，将主协议约定的管理费率调整为百分之【{{ resCooperatorData.rate }}】。</span>
        </div>
      </div>
      <div class="text marginBottom13">第二条 其他条款</div>
      <div class="display_flex_box marginBottom13">
        <span class="indent20_box">1、</span>
        <div class="text_black">
          <span
            >除上述修改内容外主协议其他内容不做改动，本协议与主协议冲突部分以本协议为准，本协议未作约定或约定不明的按照主协议继续履行；</span
          >
        </div>
      </div>
      <div class="display_flex_box marginBottom13">
        <span class="indent20_box">2、</span>
        <div class="text_black">
          <span>本协议双方签字盖章后生效；</span>
        </div>
      </div>
      <div class="display_flex_box marginBottom13">
        <span class="indent20_box">3、</span>
        <div class="text_black">
          <span>本协议一式两份，甲乙双方各持一份。</span>
        </div>
      </div>
      <div class="marginBottom23">
        <span>(以下无正文)</span>
      </div>
      <div class="flex_row_box">
        <div class="box_one">
          <div class="marginBottom23 text">
            甲方：【{{ resCooperatorData.cooperatorName }}】
          </div>
          <div class="marginBottom13 text">(盖章)</div>
        </div>
        <div class="box_one">
          <div class="marginBottom23 text">
            乙方：【{{ resCooperatorData.distributeCompanyName }}】
          </div>
          <div class="marginBottom13 text">(盖章)</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userMessage: {
      type: Object,
      default: {}
    },
    modalHeight: {
      type: String,
      default: ""
    },
    resCooperatorData: {
      type: Object,
      default: {}
    },
    modalHeight: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
// 签署合同样式
.contract-main {
  width: 100%;
  overflow-x: hidden;
  .contract-content {
    width: 100%;
    padding: 0 140px;
    font-family: STKaitiSC, STKaitiSC;
    .title {
      font-weight: 600;
      font-size: 22px;
      color: #272727;
      margin: 40px 0 24px;
      text-align: center;
    }
    .text {
      display: block;
      font-weight: bold;
      font-size: 18px;
      color: #272727;
      line-height: 25px;
    }
    .imgBox {
      width: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .indent_box,
    .indent20_box {
      font-family: STKaitiSC, STKaitiSC !important;
      font-size: 16px;
      color: #272727;
      text-indent: 5px;
      margin-top: 5px;
      span {
        &:nth-child(2) {
          margin-left: 17px;
        }
        i {
          text-align: center;
          display: inline-block;
          width: 103px;
          font-style: normal;
          border-bottom: 1px solid #272727;
        }
      }
    }
    .indent20_box {
      text-indent: 20px;
      margin-top: 0;
      white-space: nowrap;
    }
    .text_black {
      color: #272727;
      font-size: 16px;
    }
    .flex_row_box {
      display: flex;
      .box_one {
        width: 600px;
      }
    }
    .margin_box {
      margin-left: 20px;
      line-height: 30px;
      text-indent: 30px;
    }
    .margin-box {
      display: inline-block;
      margin-top: 5px;
      margin-left: 53px;
      font-family: STKaitiSC, STKaitiSC;
      font-size: 16px;
      color: #272727;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }
    .table_box {
      margin-left: 53px;
      margin-top: 12px;
      margin-bottom: 10px;
    }
    .table_padding {
      padding: 0 36px 0 18px;
    }
    .flex_box {
      display: flex;
      font-size: 15px;
      color: #272727;
      justify-content: space-between;
      margin-top: 8px;
      span {
        display: block;
        width: 235px;
        text-indent: 5px;
      }
      div {
        line-height: 25px;
        span {
          display: block;
          width: 100%;
        }
      }
      i {
        text-align: center;
        display: inline-block;
        width: 180px;
        font-style: normal;
        border-bottom: 1px solid #272727;
      }
    }
    .flex_box_spn {
      display: flex;
      font-size: 15px;
      color: #272727;
      justify-content: space-between;
      margin-top: 8px;
      span {
        display: block;
        width: 45px;
        text-indent: 5px;
      }
      div {
        font-size: 15px;
        color: #272727;
        width: calc(100% - 45px);
        span {
          font-size: 16px;
          display: block;
          width: 100%;
        }
      }
    }
    .marginLeft {
      margin-left: 65px;
    }
    .marginRight {
      margin-right: 28rpx;
      span {
        display: block;
        text-align: right;
        margin-bottom: 23px;
      }
    }
  }
}
.marginBottom23 {
  margin-bottom: 23px;
  span {
    font-family: STKaitiSC, STKaitiSC;
    font-size: 16px;
    color: #272727;
    i {
      text-align: center;
      display: inline-block;
      width: 103px;
      font-style: normal;
      border-bottom: 1px solid #272727;
    }
  }
}
.marginBottom13 {
  margin-bottom: 13px;
}
.marginBottom8 {
  margin-bottom: 8px;
}

.height335 {
  height: 335px;
}
.height460 {
  height: 460px;
}
.height212 {
  height: 212px;
}
.height448 {
  height: 448px;
}
.height168 {
  height: 168px;
}
.height796 {
  height: 796px;
}
.display_flex_box {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/indexStatistic/component/priceIncrease.vue